export enum CLUSTER_BUTTON_TYPES {
  TURNTABLE = 'turntable',
  INTERIOR_360 = 'interior_360',
  DAY = 'day',
  NIGHT = 'night',
  DETAIL = 'detail',
  INTERIOR = 'interior',
  EXTERIOR = 'exterior',
  CERTIFIED_PREOWNED = 'preOwned',
  UNKNOWN = '',
}
